import { MultiSelect as MantineMultiSelect } from '@mantine/core';
import type { MultiSelectProps as MantineMultiSelectProps } from '@mantine/core';
import './MultiSelect.css';

export interface MultiSelectProps extends Omit<MantineMultiSelectProps, 'error' | 'value' | 'onChange'> {
    error?: string;
    value?: (string | number)[] | null;
    onChange?: (value: (string | number)[]) => void;
    /** Удобный алиас для Mantine 8+: `comboboxProps={{ withinPortal }}` (внутри Popover обычно false). */
    withinPortal?: boolean;
}

export default function MultiSelect({
    error,
    className = '',
    value,
    onChange,
    withinPortal,
    comboboxProps,
    styles,
    ...props
}: MultiSelectProps) {
    const selectClass = `multiselect ${error ? 'multiselect--error' : ''} ${className}`.trim();

    // Преобразуем value в строки для Mantine MultiSelect
    const stringValue = value?.map(v => v.toString()) || [];

    const handleChange = (values: string[]) => {
        if (!onChange) return;

        // Всегда конвертируем обратно в числа
        const convertedValues = values.map(v => Number(v));

        onChange(convertedValues);
    };

    const mergedComboboxProps = {
        zIndex: 1100,
        ...comboboxProps,
        ...(withinPortal !== undefined ? { withinPortal } : {}),
    };

    const userStyles =
        typeof styles === 'object' && styles && !Array.isArray(styles) ? styles : undefined;

    return (
        <div className="multiselect-wrapper">
            <MantineMultiSelect
                className={selectClass}
                value={stringValue}
                onChange={handleChange}
                comboboxProps={mergedComboboxProps}
                {...props}
                styles={{
                    ...userStyles,
                    inputField: {
                        minWidth: '22ch',
                        flex: '1 1 0',
                        width: 'auto',
                        ...(userStyles && typeof userStyles === 'object' && 'inputField' in userStyles
                            ? (userStyles as { inputField?: object }).inputField
                            : null),
                    },
                }}
                error={error}
            />
        </div>
    );
}

